import { render } from "./AuditLogsDialog.vue?vue&type=template&id=40ea5370"
import script from "./AuditLogsDialog.vue?vue&type=script&lang=js"
export * from "./AuditLogsDialog.vue?vue&type=script&lang=js"

import "./AuditLogsDialog.vue?vue&type=style&index=0&id=40ea5370&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__